import { GraphQLClient } from "graphql-request";

// Resolve the app-service GraphQL endpoint once. `window.app_service_url` is either an absolute
// URL (other environments) or a path fragment we resolve against the current origin (local/dev).
const url = window.app_service_url?.includes("http")
  ? new URL("/graphql", window.app_service_url)
  : new URL(window.app_service_url + "/graphql", window.location.origin);

const websocketUrl = new URL(
  url.pathname,
  `${url.protocol === "https:" ? "wss" : "ws"}://${url.host}`,
);

export { url, websocketUrl };

/** A fixed token, or a getter read at request time so the client can outlive a token refresh. */
export type TokenSource = string | (() => string);

/** Reads the token per request so the client outlives a refresh; an empty token sends no header. */
export function createAuthedClient(token: TokenSource): GraphQLClient {
  return new GraphQLClient(url.toString(), {
    errorPolicy: "none",
    // `graphql-request` accepts a lazy `headers` and calls it on every request.
    headers: (): Record<string, string> => {
      const currentToken = typeof token === "function" ? token() : token;
      return currentToken ? { authorization: `Bearer ${currentToken}` } : {};
    },
  });
}
